// SUN-327 W6 — the Quota column on the Reps "Team" tab: the person's own (Individual) %, plus the Team %
// for a manager row; a coordinator row shows the team %. Figures come from the server (`targets`, D9.3).
export interface RepTargets { individualPct: number | null; teamPct: number | null; kind?: string }

const p = (n: number) => `${Math.floor(n + 0.5)}%`;

/** Extra text next to the quota bar, or null when there is nothing to add. */
export function teamQuotaNote(targets: RepTargets | null | undefined): string | null {
  if (!targets || targets.teamPct == null) return null;
  if (targets.kind === 'coordinator') return `team ${p(targets.teamPct)}`;
  if (targets.kind === 'manager') return `Team ${p(targets.teamPct)}`;
  return null;
}
